import { render } from "./shop-sidebar-category.vue?vue&type=template&id=b0ffd78c&scoped=true"
import script from "./shop-sidebar-category.vue?vue&type=script&lang=js"
export * from "./shop-sidebar-category.vue?vue&type=script&lang=js"

import "./shop-sidebar-category.vue?vue&type=style&index=0&id=b0ffd78c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ffd78c"]])

export default __exports__